var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 18,
    height: 20,
    fill: "#280f0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14199",
    "data-name": "Group 14199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13290",
    "data-name": "Group 13290",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12960",
    "data-name": "Path 12960",
    d: "M16.973,14.907c-.182.03-.363.061-.548.08a8.233,8.233,0,0,1-.843.044A8.691,8.691,0,0,1,6.907,6.342,8.586,8.586,0,0,1,8.241,1.778c.053-.085.1-.173.157-.256a1.105,1.105,0,0,0,.082-.4A1.12,1.12,0,0,0,7.369,0c-.2.058-.4.119-.6.19A10.2,10.2,0,1,0,17.436,16.96c.167-.169.324-.348.478-.529A1.1,1.1,0,0,0,18,16.008a1.111,1.111,0,0,0-1.027-1.1M10.2,18.478A8.684,8.684,0,0,1,6.364,2.005a10.191,10.191,0,0,0,9.218,14.547c.017,0,.034,0,.051,0A8.62,8.62,0,0,1,10.2,18.478",
    transform: "translate(0 0)",
    fill: "#280f0b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d44ad71dbc5ff2e9c9e4371cd2fa26aa.svg";
export { ForwardRef as ReactComponent };